/* import __COLOCATED_TEMPLATE__ from './prism-modal-container.hbs'; */
import Component from '@ember/component';

/**
 * Implements a global container for `prism-modal` to be rendered into. It should
 * either be rendered once for the whole application (i.e. in `application.hbs`)
 * or rendered next to rendering `cap-modal`.
 *
 * ```hbs
 * {{prism-modal-container}}
 * ```
 *
 * @class PrismModalContainer
 */
export default Component.extend({
  tagName: '',
  // new modals
  handleMousedown(event) {
    this.mousedownEvent = event;
  },
  handleMouseup(onClose, event) {
    // If the target of the click is the modal screen (indiciated by a data
    // attribute) then we want to close the modal.
    if (this.mousedownEvent?.target.dataset.modalScreen &&
    // started on the modal screen
    event.target.dataset.modalScreen &&
    // finished on the modal screen
    event.button === 0 &&
    // left click
    onClose) {
      onClose();
    }
    delete this.mousedownEvent;
  },
  // old modals
  handleClick(closeFunction, event) {
    // If the target of the click is the modal screen (indiciated by a data
    // attribute) then we want to close the modal.
    if (event.target.dataset.modalScreen) {
      closeFunction();
    }
  }
});